<template>
  <!-- Interruptor. É um `checkbox` de verdade por baixo: leitor de tela anuncia estado e
       o teclado alcança sem código extra. -->
  <label class="switch" :class="{ on: modelValue }">
    <input
      type="checkbox"
      :checked="modelValue"
      :aria-label="label"
      @change="$emit('update:modelValue', $event.target.checked)"
    >
    <span class="track" aria-hidden="true"><span class="knob" /></span>
  </label>
</template>

<script>
export default {
  name: 'AppSwitch',
  props: {
    modelValue: { type: Boolean, default: false },
    /** O que este interruptor liga — a linha de configuração passa o próprio título. */
    label: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
};
</script>

<style scoped>
/* O alvo é a etiqueta inteira, com os 44px da diretiva 09; o desenho é a pista. */
.switch {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: var(--touch);
  min-height: var(--touch);
  cursor: pointer;
}

/* O input fica invisível, mas continua no fluxo do foco. */
.switch input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.track {
  width: 46px;
  height: 27px;
  padding: 3px;
  border-radius: var(--r-pill);
  background: var(--veil-3);
  border: 1px solid var(--line);
  display: flex;
  justify-content: flex-start;
  transition: background 0.16s, border-color 0.16s;
}

/* Ligado é gradiente da marca: é a mesma cor que diz "agora" no resto do app. */
.switch.on .track {
  background: var(--brand-gradient);
  border-color: transparent;
  justify-content: flex-end;
}

/* Desligado, a bolinha é o texto terciário: ela precisa aparecer sobre o trilho nos três
   temas, e `--text` viraria uma bola preta no claro. */
.knob {
  width: 21px;
  height: 21px;
  border-radius: var(--r-pill);
  background: var(--text-3);
  transition: transform 0.16s;
}

.switch.on .knob { background: var(--on-brand); }

.switch input:focus-visible + .track { outline: 2px solid var(--active); outline-offset: 2px; }
</style>
